// extracted by mini-css-extract-plugin
export default {"root":"Input_root__HrSva","label":"Input_label__cJ9i-","children":"Input_children__70z-d"};